<template>
  <div>
    <FITModal ref="deleteBulletinModal" reference="modal" :title="$t('general.CURD.delete')" @click="onClickModalDelete">
      <div slot="body">
        <h5 class="mb-3">{{$t('adm.bulletin.deleteConfirmTitle')}}</h5>
        <p class="my-2"><b>{{$t('adm.bulletin.subject')}}: {{selectedRow.subject}}</b></p>
        <p class="my-2"><b>{{$t('adm.bulletin.content')}}: {{selectedRow.preview}}</b></p>
      </div>
    </FITModal>
    <FITAlert ref="alert" :alertContent="alertParams.content" :variant="alertParams.variant" :alertSec="3" :dismissible="true"></FITAlert>
    <BulletinView ref="bulletinView" :editable="true"></BulletinView>
    <FITFormCard>
      <div slot="header">
        <b-row align-v="center" class="pb-2">
          <b-col cols="6">
            <span class="h4">{{ $t('adm.bulletin.header') }}</span>
          </b-col>
          <b-col cols="6" class="text-right">
            <b-button variant="primary" size="md" @click="createBulletin"><i class="fa fa-plus-circle mr-2"></i>{{ $t('adm.bulletin.create') }}</b-button>
          </b-col>
        </b-row>
      </div>
      <div slot="formBody">
        <FITSearchableTable ref="table" :filters="filters" :actions="actions" :columns="columns" searchAction="getBulletinList" vuexModule="Adm" type="bulletin"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script>
import {
  FITSearchableTable,
  FITFormCard,
  FITModal,
  FITAlert
} from '@/components'

import {
  BulletinView
} from '@/Homepage/components'

import { mapGetters, mapState } from 'vuex'

import Vue from 'vue'

export default {
  name: 'BulletinList',
  components: {
    FITSearchableTable,
    FITFormCard,
    BulletinView,
    FITModal,
    FITAlert
  },
  props: {
    alertContent: {
      type: String,
      default: null
    },
    alertVariant: {
      type: String,
      default: null
    }
  },
  created() {
    // this.getProviderOptions();
  },
  mounted() {
    if (this.alertContent) {
      this.setAlert();
      this.$refs.alert.showAlert();
    }
  },
  methods: {
    // getProviderOptions() {
    //   this.$store.dispatch('Adm/getProviderOptions', { count: 2000 }).then((json) => {
    //     this.$store.commit({ type: 'Adm/setProviderOptions', providers: json.data.list });

    //     let providersFilters = {
    //       label: this.$t('adm.bulletin.provider'),
    //       key: 'provider',
    //       type: 'select',
    //       default: '213213', // Default All
    //       // options: this.providersOptions
    //     }
    //     var filters = this.filters

    //     filters.splice(1, 0, providersFilters);
    //     Vue.set(this, 'filters', filters);
    //     Vue.set(this, 'isLoading', false);
    //   }).catch((err) => {
    //     Vue.set(this, 'isLoading', false);
    //     console.error(err);
    //   })
    // },
    setAlert() {
      if (this.alertContent) {
        Vue.set(this.alertParams, 'content', this.alertContent);
      }
      if (this.alertVariant) {
        Vue.set(this.alertParams, 'variant', this.alertVariant);
      }
    },
    onClickModalDelete(evt) {
      if (evt) {
        this.$store.dispatch('Adm/deleteBulletin', { ID: this.selectedRow.ID }).then((json) => {
          this.$refs.table.search();
          this.$refs.deleteBulletinModal.closeModal();
          Vue.set(this, 'alertParams', { content: this.$t('general.deleteSuccess'), variant: 'success' });
          this.$refs.alert.showAlert();
          window.scrollTo(0, 0);
        })
      }
    },
    createBulletin() {
      this.$router.push({
        name: 'Create Bulletin'
      })
    },

    onRowClicked(row) {
      console.debug(row)
    },

    getTranslated(type, key) {
      if (!key) {
        return 'N/A';
      }
      let result = this.getTranslatedArray(this.$i18n.locale, 'Adm', type)
        .filter((item) => {
          return item.value === key
        });
      if (result.length > 0) {
        return result[0].text;
      }
      return 'N/A';
    }
  },

  computed: {
    ...mapGetters(['getTranslatedArray']),
    ...mapGetters("Adm", ['getProviderSelections']),
    providersOptions() {
      let obj = this.getProviderSelections();
      obj.unshift({ text: this.$t('general.all'), value: null });
      return obj
    }
  },
  data() {
    return {
      isLoading: true,
      alertParams: {
        content: '',
        variant: 'success'
      },
      selectedRow: {},
      columns: [{
        key: 'category',
        label: this.$t('adm.bulletin.category'),
        sortable: true,
        formatter: (row, key, item) => {
          return this.getTranslated('category', row);
        }
      }, {
        key: 'subject',
        label: this.$t('adm.bulletin.subject'),
        sortable: true,
        thClass: 'bulletin-subject'
      }, {
        key: 'preview',
        label: this.$t('adm.bulletin.preview'),
        formatter: (row, key, item) => {
          return row.substring(0, 85) + '...';
        }
      }, {
        key: 'createTime',
        label: this.$t('adm.bulletin.createTime'),
        thClass: ['bulletin-time', 'text-center'],
        tdClass: ['text-center'],
        sortable: true,
        formatter: (row, key, item) => {
          return Vue.options.filters.date(row);
        }
      }, {
        key: 'updateTime',
        label: this.$t('adm.bulletin.updateTime'),
        sortable: true,
        thClass: ['bulletin-time', 'text-center'],
        tdClass: ['text-center'],
        formatter: (row, key, item) => {
          return Vue.options.filters.date(row);
        }
      }],

      actions: [{
          text: this.$t('adm.bulletin.edit'),
          key: 'edit',
          callback: (key, row, instance) => {
            let ID = parseInt(row.ID);
            this.$router.push({
              name: 'Create Bulletin',
              params: { bulletin: ID }
            })
          }
        },
        {
          text: this.$t('adm.bulletin.view'),
          key: 'view',
          callback: (key, row, instance) => {
            this.$refs.bulletinView.show(row.ID);
          }
        }, {
          text: this.$t('general.CURD.delete'),
          key: 'delete',
          callback: (key, row, instance) => {
            Vue.set(this, 'selectedRow', row);
            this.$refs.deleteBulletinModal.openModal();
          },
          class: 'text-danger'
        }
      ],

      filters: [{
          label: this.$t('adm.bulletin.category'),
          key: 'category',
          type: 'select',
          default: null, // Default All
        },
        {
          label: this.$t('adm.bulletin.provider'),
          key: 'providerID',
          type: 'select',
          default: null, // Default All
          // options: this.providersOptions
        },
        {
          label: this.$t('adm.bulletin.policyType'),
          key: 'policyType',
          type: 'select',
          default: null, // Default All
        },
        {
          label: this.$t('general.fromDate'),
          key: 'fromDate',
          type: 'datetime',
          default: ''
        },
        {
          label: this.$t('general.toDate'),
          key: 'toDate',
          type: 'datetime',
          default: ''
        }
      ],
      form: {},
    }
  }
}

</script>
<style>
.bulletin-subject {
  width: 450px;
  max-width: 450px;
}

.bulletin-time {
  width: 150px;
}

</style>



// WEBPACK FOOTER //
// src/Adm/Bulletin/BulletinList.vue